var map = {
	"./building.vue": [
		"1a5c",
		"chunk-1bc4eadb"
	],
	"./company.vue": [
		"60f1",
		"chunk-9e8c3918",
		"chunk-582a2301"
	],
	"./contactus.vue": [
		"7865",
		"chunk-9e8c3918",
		"chunk-4b32de04"
	],
	"./index.vue": [
		"1e4b",
		"chunk-9e8c3918",
		"chunk-e9623806",
		"chunk-2f55734e"
	],
	"./news/details.vue": [
		"ea76",
		"chunk-9e8c3918",
		"chunk-4ccaf61d",
		"chunk-9d1ae19c"
	],
	"./news/index.vue": [
		"7c64b",
		"chunk-9e8c3918",
		"chunk-4ccaf61d",
		"chunk-6274d3ac"
	],
	"./product.vue": [
		"146f",
		"chunk-9e8c3918",
		"chunk-56aae189"
	],
	"./productDetail.vue": [
		"2e1b",
		"chunk-9e8c3918",
		"chunk-e9623806",
		"chunk-fdff2f90"
	],
	"./recruit.vue": [
		"6f96",
		"chunk-9e8c3918",
		"chunk-cd7a659c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;